import React, { useState } from 'react'
import Calculator from './Calculator'
import Results from './Results'
import './App.css'

const App = () => {
  const [total, setTotal] = useState();
  
  function totalG(t){
    setTotal(t);
  }

  return (
    <div  className='content'>
      <Calculator totalG={totalG} />
      <Results total={total} />
    </div>
  )
}

export default App